import { JSX } from 'react';

import { DynamicPinForm } from '@/components/secret/PinInput/components/DynamicPinForm.tsx';
import { EmailVerification } from '@/components/secret/PinInput/components/EmailVerification.tsx';
import { SecurityKeyAuth } from '@/components/secret/PinInput/components/SecurityKeyAuth.tsx';
import { StaticPinForm } from '@/components/secret/PinInput/components/StaticPinForm.tsx';

import { PinInputEmailCodeProps, PinInputEmailGuessProps, PinInputPinModeProps } from './types.ts';

// =============================================================================
// Types
// =============================================================================

// type PinInputMode = 'pin' | 'email_guess' | 'email_code';

// =============================================================================
// Component
// =============================================================================

export const PinInput = (
    props: PinInputPinModeProps | PinInputEmailGuessProps | PinInputEmailCodeProps
): JSX.Element => {
    const { mode, pinType, error, isLoading } = props;

    // Email verification modes
    if (mode === 'email_guess') {
        const emailProps = props as PinInputEmailGuessProps;

        return (
            <EmailVerification
                mode="email_guess"
                onSubmitEmailGuess={emailProps.onSubmitEmailGuess}
                onSubmitEmailCode={emailProps.onSubmitEmailCode}
                emailGuessValue={emailProps.emailGuessValue}
                error={error}
                isLoading={isLoading}
                hintEnabled={emailProps.emailHintEnabled}
                hintValue={emailProps.emailHintValue}
            />
        );
    }

    if (mode === 'email_code') {
        const emailProps = props as PinInputEmailCodeProps;
        return (
            <EmailVerification
                mode="email_code"
                onSubmitEmailGuess={emailProps.onSubmitEmailGuess}
                onSubmitEmailCode={emailProps.onSubmitEmailCode}
                error={error}
                isLoading={isLoading}
                hintEnabled={emailProps.emailHintEnabled}
                hintValue={emailProps.emailHintValue}
            />
        );
    }

    // PIN mode - switch by pinType
    const pinModeProps = props as PinInputPinModeProps;

    switch (pinType) {
        case 'dynamic':
            return <DynamicPinForm onSubmit={pinModeProps.onSubmitPin} error={error} isLoading={isLoading} />;

        case 'securityKey':
            return (
                <SecurityKeyAuth
                    onSubmit={pinModeProps.onSubmitPin}
                    error={error}
                    isLoading={isLoading}
                    challenge={pinModeProps.securityKeyChallenge}
                />
            );

        case 'email':
            // If pinType is 'email' but mode is 'pin', show email verification
            // This case handles when URL has pinType=email
            return <EmailVerification mode="email_guess" error={error} isLoading={isLoading} />;

        case 'static':
        default:
            return <StaticPinForm onSubmit={pinModeProps.onSubmitPin} error={error} isLoading={isLoading} />;
    }
};
